<script>
  import {M} from "../external";

  export let data, onClick, onDeleteClick;
</script>
<div class="filter-option-wrapper f-left">
    <div class="filter-option" on:click={onClick}>
        <span role="name" class="option-name">{data.name}</span>
        <span role="filter">{data.filter}</span>
        <span role="value">{data.value}</span>
        <span role="suffix">{data.suffix}</span>
        <a class="filter-delete" on:click={onDeleteClick}>
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                 x="0px" y="0px"
                 width="10px" height="10px" viewBox="0 0 357 357" style="enable-background:new 0 0 357 357;"
                 xml:space="preserve">
                  <polygon
                          points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"/>
                  </svg>
        </a>
    </div>
    <div class="filter-divider">{M.AND}</div>
</div>